import { render } from "./DCardSection.vue?vue&type=template&id=6a89dd72&scoped=true"
const script = {}

import "./DCardSection.vue?vue&type=style&index=0&id=6a89dd72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a89dd72"]])

export default __exports__